// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"9f2bfbb6","940":"a50868b8"}[chunkId] + ".chunk.js";
};